import React, { useState } from 'react';
import classes from './style.module.css';
import PropTypes from 'prop-types';
import { logInfo/*, logError*/ } from '../../../util/log/logger'
import { FORGOT_PASSWORD_FORM_FIELDS } from '../../../constants/Constants'
import { LOGIN_STATUS } from '../../../constants/Constants'

const ForgotPasswordForm = props => {

    const [username, setUsername] = useState("");
    const [passwordNew, setPasswordNew] = useState("");
    const [passwordNewVerify, setPasswordNewVerify] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [inputErrorMessage, setInputErrorMessage] = useState(null);

    const validateInputs = () => {
        return passwordNew === passwordNewVerify
    }

    const requestVerificationCodeHandler = async () => {
        await props.forgotPasswordRequestVerificationClicked(username)
    }


    const submitNewPasswordHandler = async () => {
        if (validateInputs()) {
            logInfo("submitNewPasswordHandler | new and confirm passwords matched")
            setInputErrorMessage(null)
            await props.forgotPasswordNewPasswordSubmit(verificationCode, passwordNew)
        } else {
            logInfo("submitNewPasswordHandler | Password mismatch or incorrect verification code. Please check and re-enter again")
            setInputErrorMessage("Password mismatch or incorrect verification code. Please check and re-enter again")
        }
    }

    let fieldErrors = null;
    if (inputErrorMessage) {
        fieldErrors = <div className={classes.FieldErrors}>
            {inputErrorMessage}
        </div>
    }

    let activeForm = null
    if (props.loginStatus === LOGIN_STATUS.FORGOT_PASSWORD_REQUEST) {
        activeForm = <>
            <div className={classes.InfoMessage}>
                Provide registered username/email to receive password reset verification code
            </div>
            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormUsernameInput">
                    {FORGOT_PASSWORD_FORM_FIELDS.USERNAME_TEXT.label}
                </label>
                <input
                    id="loginFormUsernameInput"
                    className={classes.FormControl}
                    key={FORGOT_PASSWORD_FORM_FIELDS.USERNAME_TEXT.key}
                    type="text"
                    placeholder={FORGOT_PASSWORD_FORM_FIELDS.USERNAME_TEXT.placeHolder}
                    value={username}
                    onChange={(event) => { setUsername(event.target.value) }} />
                <small className={classes.FormText}>
                    We'll never share your email with anyone else.
                </small>
            </div>
            <button
                type="button"
                className={classes.SubmitButton}
                onClick={requestVerificationCodeHandler}>
                {FORGOT_PASSWORD_FORM_FIELDS.REQUEST_VERIFICATION_CODE_BUTTON.label}
            </button>
        </>
    } else if (props.loginStatus === LOGIN_STATUS.FORGOT_PASSWORD_PENDING_VERIFICATION) {
        activeForm = <>
            <div className={classes.InfoMessage}>
                Enter verification code received to your email and provide your desired password
            </div>
            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormVerificationCodeInput">
                    {FORGOT_PASSWORD_FORM_FIELDS.VERIFICATION_CODE_TEXT.label}
                </label>
                <input
                    id="loginFormVerificationCodeInput"
                    className={classes.FormControl}
                    key={FORGOT_PASSWORD_FORM_FIELDS.VERIFICATION_CODE_TEXT.key}
                    type="text"
                    placeholder={FORGOT_PASSWORD_FORM_FIELDS.VERIFICATION_CODE_TEXT.placeHolder}
                    value={verificationCode}
                    onChange={(event) => { setVerificationCode(event.target.value); setInputErrorMessage(null) }} />
            </div>

            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormPasswordInputNew">
                    {FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.label}
                </label>
                <input
                    id="loginFormPasswordInputNew"
                    className={classes.FormControl}
                    key={FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.key}
                    type="password"
                    placeholder={FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_TEXT.placeHolder}
                    value={passwordNew}
                    onChange={(event) => { setPasswordNew(event.target.value); setInputErrorMessage(null) }} />
            </div>

            <div className={classes.FormGroup}>
                <label className={classes.FormLabel} htmlFor="loginFormPasswordInputNewVerify">
                    {FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.label}
                </label>
                <input
                    id="loginFormPasswordInputNewVerify"
                    className={classes.FormControl}
                    key={FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.key}
                    type="password"
                    placeholder={FORGOT_PASSWORD_FORM_FIELDS.PASSWORD_NEW_VERIFY_TEXT.placeHolder}
                    value={passwordNewVerify}
                    onChange={(event) => { setPasswordNewVerify(event.target.value); setInputErrorMessage(null) }} />
            </div>
            {fieldErrors}
            <button
                type="button"
                className={classes.SubmitButton}
                onClick={submitNewPasswordHandler}>
                {FORGOT_PASSWORD_FORM_FIELDS.SUBMIT_BUTTON.label}
            </button>
        </>
    }

    return (
        <div className={classes.ForgotPasswordForm}>
            <div className={classes.FormTitle}>{props.title}</div>
            <div className={classes.FormSubtitle}>Forgot Password</div>
            {activeForm}
        </div>
    )
}

ForgotPasswordForm.propTypes = {
    loginStatus: PropTypes.string.isRequired,
    forgotPasswordRequestVerificationClicked: PropTypes.func.isRequired,
    forgotPasswordNewPasswordSubmit: PropTypes.func.isRequired,
}

export default ForgotPasswordForm